import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { ChartConfig } from 'recharts';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const chartConfig = {
  count: {
    label: 'Count',
    color: 'hsl(var(--primary))',
  },
} satisfies ChartConfig;
